import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaRepassesFundosInstitutosPrevidenciarios: ['exercicio'],
    setAdministracaoConsultaRepassesFundosInstitutosPrevidenciarios: ['administracao'],
    limpaFiltroConsultaRepassesFundosInstitutosPrevidenciarios: [],
    receberFiltroConsultaRepassesFundosInstitutosPrevidenciarios: ['filtroRecebido'],
    setStatusConsultaRepassesFundosInstitutosPrevidenciarios: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: '',
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: setAdministracao,
    [Types.LIMPA_FILTRO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_REPASSES_FUNDOS_INSTITUTOS_PREVIDENCIARIOS]: setStatus,
})
